const getVisibleTextLength = (html) => {
  if (typeof html !== "string" || !html) return 0;
  if (typeof document === "undefined") {
    return html
      .replace(/<[^>]+>/g, "")
      .replace(/[\u200b\ufeff\u00a0]/g, "")
      .replace(/\s+/g, "")
      .trim().length;
  }
  const el = document.createElement("div");
  el.innerHTML = html;
  const raw = el.textContent || el.innerText || "";
  return raw
    .replace(/[\u200b\ufeff\u00a0]/g, "")
    .replace(/\s+/g, "")
    .trim().length;
};

export const isHtmlNoteVisuallyEmpty = (html) => getVisibleTextLength(html) === 0;

export const CANONICAL_EMPTY_NOTE_HTML = "<p><br></p>";
